import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './HolidaySafety.module.scss';

const HolidaySafety = () => {
    const { t } = useTranslation();
    return (
        <>
            <strong>{t('TRANS-tooltip-holiday-safety-headline')}</strong>
            <ul
                className={styles.List}
                dangerouslySetInnerHTML={{
                    __html: t('TRANS-tooltip-holiday-safety-info'),
                }}
            />
        </>
    );
};

export default HolidaySafety;
